// extracted by mini-css-extract-plugin
export default {"card":"xY-z","carouselContainer":"yY-z","carouselContent":"zY-z"};